import { Image } from "@hl/base-components/lib/assets/icons.generated";
import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import { WEIGHT_BOLD } from "@hl/base-components/lib/theme/typography";
import { ResizedImage } from "@hl/shared-features/lib/features/image";
import { networkLookup } from "@hl/shared-features/lib/utils/blockExplorer";
import { Center, Group, Stack, Text } from "@mantine/core";

import { _CollectionType } from "apollo/graphql.generated";
import { BlockchainEntity } from "components/BlockchainEntityTitle/types";
import { collectionTypeToDisplayName } from "~/features/collections/displayUtils";
import StatusBadge from "~/features/collections/sections/ContractCollectionDashboard/StatusBadge";
import BlockchainEntityMenu from "~/features/collections/sections/ContractCollectionDashboard/menu/BlockchainEntityMenu";

const CollectionCard = ({
  blockchainEntity,
  width,
  height,
}: {
  blockchainEntity: BlockchainEntity;
  width?: number | string;
  height?: number | string;
}) => {
  const networkData = blockchainEntity.chainId
    ? networkLookup(blockchainEntity.chainId)
    : null;

  return (
    <StatusBadge blockchainEntity={blockchainEntity}>
      <Stack spacing={8}>
        <Center
          sx={(theme) => ({
            aspectRatio: "1",
            width,
            height,
            border: `0.5px solid ${theme.colors.divider[0]}`,
          })}
        >
          {blockchainEntity.details.image ? (
            <ResizedImage
              aspectRatio="1"
              fit="contain"
              src={blockchainEntity.details.image}
            />
          ) : (
            <Image width={20} height={20} />
          )}
        </Center>
        <Group position="apart" align="center" noWrap>
          <Stack spacing={0}>
            <Text size="xl" weight={WEIGHT_BOLD}>
              {blockchainEntity.details.name}
            </Text>
            <Text size="sm" color={TEXT_COLOR.SECONDARY}>
              <Stack spacing={0}>
                <Group spacing={6}>
                  <span>
                    {collectionTypeToDisplayName(
                      blockchainEntity.collectionType
                    )}
                  </span>
                  {networkData && (
                    <>
                      <span>·</span>
                      <span>{networkData.displayName}</span>
                    </>
                  )}
                </Group>
                {/* Limited and Open editions mint type */}
                {blockchainEntity.type === "mint" &&
                  (blockchainEntity.collectionType ===
                    _CollectionType.LimitedEdition ||
                    blockchainEntity.collectionType ===
                      _CollectionType.OpenEdition) &&
                  blockchainEntity.mintStatus && (
                    <span>{`${blockchainEntity.mintStatus.minted}${
                      blockchainEntity.mintStatus.total
                        ? `/${blockchainEntity.mintStatus.total}`
                        : ""
                    } minted`}</span>
                  )}
                {/* Series */}
                {blockchainEntity.collectionType === _CollectionType.Series &&
                  blockchainEntity.mintStatus?.total && (
                    <span>Edition of {blockchainEntity.mintStatus.total}</span>
                  )}
                {/*1 of 1 mints and auction types*/}
                {(blockchainEntity.collectionType ===
                  _CollectionType.OneOfOne ||
                  blockchainEntity.type === "auction") && <span>1 of 1</span>}
              </Stack>
            </Text>
          </Stack>
          <BlockchainEntityMenu entity={blockchainEntity} />
        </Group>
      </Stack>
    </StatusBadge>
  );
};

export default CollectionCard;
